import React from 'react';
import { motion } from 'framer-motion';
import { FaGithub, FaLinkedin, FaEnvelope, FaMapMarkerAlt, FaDownload } from 'react-icons/fa';
import AuroraBackground from './AuroraBackground';
import ParticleBackground from './ParticleBackground';
import portfolioData from '../data/portfolio.json';
import './About.css';

const About = () => {
    const profile = portfolioData.profile;

    return (
        <div className="about">
            <AuroraBackground />
            <ParticleBackground particleCount={30} />
            <div className="container">
                {/* Hero Section */}
                <motion.section
                    className="about-hero"
                    initial={{ opacity: 0, y: 30 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                >
                    <div className="about-content">
                        <div className="about-image">
                            <div className="profile-placeholder">
                                <img 
                                    src="/pfp.jpg" 
                                    alt="Vasudev Kishor" 
                                    className="profile-image"
                                />
                            </div>
                        </div>

                        <div className="about-text">
                            <h1 className="about-title">
                                About <span className="highlight">Me</span>
                            </h1>
                            <p className="about-description">
                                {profile?.bio || 'Passionate developer with a love for creating innovative solutions.'}
                            </p>

                            <div className="about-details">
                                <div className="detail-item">
                                    <FaEnvelope className="detail-icon" />
                                    <span>{profile?.email || 'your.email@example.com'}</span>
                                </div>
                                <div className="detail-item">
                                    <FaMapMarkerAlt className="detail-icon" />
                                    <span>{profile?.location || 'Your City, Country'}</span>
                                </div>
                            </div>

                            <div className="about-actions">
                                <motion.a
                                    href="/Vasudev Kishor Resume .pdf"
                                    download="Vasudev_Kishor_Resume.pdf"
                                    className="btn btn-primary"
                                    whileHover={{ scale: 1.05 }}
                                    whileTap={{ scale: 0.95 }}
                                >
                                    <FaDownload /> Download Resume
                                </motion.a>
                            </div>
                        </div>
                    </div>
                </motion.section>

                {/* Skills Section */}
                <motion.section
                    className="skills-section"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <h2 className="section-title">Skills</h2>
                    <div className="skills-grid">
                        {profile?.skills?.filter(skill =>
                            !['Git', 'Docker', 'AWS'].includes(skill)
                        ).map((skill, index) => (
                            <motion.div
                                key={skill}
                                className="skill-item"
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <span className="skill-name">{skill}</span>
                            </motion.div>
                        ))}
                    </div>
                </motion.section>

                {/* Tools Section */}
                <motion.section
                    className="tools-section"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <h2 className="section-title">Tools</h2>
                    <div className="skills-grid">
                        {profile?.skills?.filter(skill =>
                            ['Git', 'Docker', 'AWS'].includes(skill)
                        ).map((skill, index) => (
                            <motion.div
                                key={skill}
                                className="skill-item"
                                initial={{ opacity: 0, x: -20 }}
                                whileInView={{ opacity: 1, x: 0 }}
                                transition={{ duration: 0.4, delay: index * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <span className="skill-name">{skill}</span>
                            </motion.div>
                        ))}
                    </div>
                </motion.section>

                {/* Social Links */}
                <motion.section
                    className="social-section"
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    viewport={{ once: true }}
                >
                    <h2 className="section-title">Connect With Me</h2>
                    <div className="social-grid">
                        {profile?.social_links && (
                            <>
                                <motion.a
                                    href={profile.social_links.github}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-card"
                                    whileHover={{ scale: 1.05, y: -5 }}
                                >
                                    <FaGithub className="social-icon" />
                                    <span>GitHub</span>
                                </motion.a>
                                <motion.a
                                    href={profile.social_links.linkedin}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="social-card"
                                    whileHover={{ scale: 1.05, y: -5 }}
                                >
                                    <FaLinkedin className="social-icon" />
                                    <span>LinkedIn</span>
                                </motion.a>
                            </>
                        )}
                    </div>
                </motion.section>
            </div>
        </div>
    );
};

export default About; 